export default __webpack_public_path__ + "static/media/tms-general.bdd5a48d.pdf";